<!--
 * @Description: 促销政策右侧弹框
 * @Autor: txp
 * @Date: 2021-04-28 15:39:26
-->
<template>
  <div class="shopsettlereplen">
    <el-drawer title="商品政策"
               :lock-scroll="false"
               :size="width"
               :visible.sync="dialogVisible"
               :before-close="handleClose"
               :direction="direction">
      <div class="shopsettlereplen_drawer">
        <div class="info">
          <ReplenOrderInfo v-if="dialogVisible"  ref="promotionList" :promotionCodes="promotionCode"  :promotionParams="promotionParams" />
        </div>
        <div class="btn">
          <el-button size="small" @click="cancel">取消</el-button>
          <!-- <el-button size="small" type="primary"
                     @click="submit">确定</el-button> -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ReplenOrderInfo from "../ShopSettle/Components/ReplenOrderInfo";
export default {
  name: "shopsettlereplen",
  data() {
    return {
      direction: "rtl", //抽屉打开方向
      width: "60%", //抽屉的宽度
      activeName: "first", //切换抽屉table
      pageSize: 10,
      pageNum: 1,
      total: 0
    };
  },
  props: {
    visible: {
      //是否显示
      type: Boolean,
      default: false
    },
    promotionParams: {
      type: Object
    },
    promotionCode: Array
  },
  components: {
    ReplenOrderInfo
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val); // openCardDialog改变的时候通知父组件
      }
    },
    ...mapGetters({
      theme: "theme"
    })
  },
  methods: {
    submit() {
        this.$emit('submit',this.$refs.promotionList.promotionList)
    },
    cancel(){
        this.$emit('handleClose')
    },
    // 关闭
    handleClose() {
      this.$emit("handleClose");
    },
    // 切换弹框类目
    handleClick(tab) {
      this.activeName = tab.name;
    },
    // 分页处理
    nextClick(nextPageNum) {
      this.pageNum = nextPageNum;
      this.getDataMyOrder();
    },
    prevClick(prevPageNum) {
      this.pageNum = prevPageNum;
      this.getDataMyOrder();
    },
    currentClick(currentPageNum) {
      this.pageNum = currentPageNum;
      this.getDataMyOrder();
    }
  }
};
</script>
<style lang="scss" scoped>
.shopsettlereplen {
  position: relative;
  /deep/.el-drawer__header {
    font-size: 20px;
    color: #1d1d1d;
    margin-bottom: 0px;
  }
  /deep/.el-drawer__body {
    overflow: hidden;
  }
  .shopsettlereplen_drawer {
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .info {
      flex: 1;
      overflow: auto;
    }
    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    //分页
    .pageschange {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translate(0, -50%);
    }
  }
}
</style>
